import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import dayjs from "dayjs";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function uuid(prefix?: string): string {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    const id = v.toString(16);
    return prefix ? `${prefix}${id}` : id;
  });
}

export function downloadBase64PDF(
  dataUrl: string,
  fileName: string = `pdf-${dayjs().format("DD-MM-YYYY")}.pdf`,
) {
  // Create anchor element and set href to data URL
  const link = document.createElement("a");
  link.href = dataUrl;
  // Set the file name and start download
  link.download = fileName;
  link.click();
}

export const ucFirst = (str: string | null) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function () {
      const dataUrl = reader.result;
      if (dataUrl) {
        // eslint-disable-next-line @typescript-eslint/no-base-to-string
        const pdf = dataUrl.toString().split("base64,")[1];
        resolve(pdf);
      }
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export const stripTags = (html: string) => {
  return html.replace(/(<([^>]+)>)/gi, "");
};

export const slugify = (text: string) => {
  return text.toString().toLowerCase().normalize("NFD").trim();
};

export const countParagraph = (paragraph: string) => {
  const words = paragraph.split(" ");
  const sentences = paragraph.split(".");
  return [words.length, sentences.length];
};

export const generateRandomString = (length: number) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
}


